<div class="form p-dialog-content h-full flex flex-column share-session">
  <form [formGroup]="shareUserForm" class="flex flex-column gap-3 w-full flex-grow-1">
    <div class="field mb-3 w-full">
      <label for="userSearch" class="block mb-2">{{ 'USER_MANAGEMENT' | translate }}</label>
      <p-multiSelect
        id="userSearch"
        [options]="allUsers"
        formControlName="user"
        optionLabel="fullName"
        [placeholder]="'SELECT_USERS' | translate"
        appendTo="body"
        styleClass="w-full"
        [filter]="true"
        [filterPlaceHolder]="'SEARCH_USERS' | translate"
      >
        <ng-template let-user pTemplate="item">
          <div class="flex align-items-center gap-2">
            <div>{{ user.firstName }} {{ user.lastName }}</div>
            <div class="text-xs text-500">({{ user.email }})</div>
          </div>
        </ng-template>
      </p-multiSelect>

      <div *ngIf="submitted && shareUserForm.controls['user'].errors" class="p-error text-sm mt-1">
        <span *ngIf="shareUserForm.controls['user'].errors['required']">{{ 'USER_IS_REQUIRED' | translate }}</span>
      </div>
    </div>

    <div class="field mb-3 w-full">
      <label for="subject" class="block mb-2">{{ 'SUBJECT' | translate }}</label>
      <input
        id="subject"
        type="text"
        pInputText
        formControlName="subject"
        class="w-100"
        [placeholder]="'ENTER_SUBJECT' | translate"
      />
      <div *ngIf="submitted && shareUserForm.controls['subject'].errors" class="p-error text-sm mt-1">
        <span *ngIf="shareUserForm.controls['subject'].errors['required']">{{
          'SUBJECT_IS_REQUIRED' | translate
        }}</span>
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-auto pt-3 border-top-1 surface-border">
      <p-button
        styleClass="cancel-btn mr-1"
        [label]="'CANCEL' | translate"
        [text]="true"
        severity="secondary"
        (click)="close()"
      ></p-button>
      <p-button
        styleClass="submit-btn"
        [label]="'SEND' | translate"
        (click)="sendMail()"
        [disabled]="shareUserForm.invalid || !shareUserForm.value.subject?.trim() || Flags.isServiceTriggered"
      ></p-button>
    </div>
  </form>
</div>
